import styled from 'styled-components'

export const ContainerActions = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 620px;

  @media (max-height: 990px) {
    height: 580px;
  }

  @media (max-height: 900px) {
    height: 500px;
  }

  @media (max-height: 800px) {
    padding-top: 0px;
    height: 430px;
  }

  @media (max-height: 600px) {
    height: 370px;
  }
`

export const ScrollContentActions = styled.div`
  display: flex;
  direction: row;
  width: 100%;
  gap: 20px;
  min-height: 560px;
  overflow: auto;

  @media (max-height: 990px) {
    min-height: 390px;
  }

  @media (max-height: 850px) {
    min-height: 380px;
  }
  @media (max-height: 750px) {
    min-height: 360px;
  }

  @media (max-height: 600px) {
    min-height: 300px;
  }
`
